import { useEffect, useState } from 'react';
import { BusinessesService } from 'service/businesses.service';
import { PlatformInsightData } from './types';

export const useBusinessDetails = (id: string) => {
  const [data, setData] = useState<PlatformInsightData | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getDetails = async (id: string) => {
      try {
        setLoading(true);
        const res = await BusinessesService.getBusinessById(id);
        setData(res);
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };

    getDetails(id);
  }, [id]);

  return { data, loading };
};
